import React from 'react'
import styled from 'styled-components'

import { Article } from '../types'
import Question from '../question'

const Container = styled.div``

type Props = {
    articles: Article[]
}

const QuestionList = ({ articles }: Props) => {
    return (
        <Container>
            {articles.length ? (
                articles.map(a => <Question article={a} key={`question-article-${a.id}`} />)
            ) : (
                <span>No FAQs found to satisfy the search query.</span>
            )}
        </Container>
    )
}

export default QuestionList
